exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-div {\n  max-height: 150px;\n  overflow: hidden;\n  border: 0px solid #035168; }\n\n.upload-div .fa {\n  font-size: 30px;\n  height: 36px;\n  color: #035168; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src1163493562/src/src/app/generic-ui-components/generic-accordion-attachment/generic-accordion-attachment.component.scss
// module id = ../../../../../src/app/generic-ui-components/generic-accordion-attachment/generic-accordion-attachment.component.scss
// module chunks = main